import React, { useState } from "react";
import searchIcon from "assets/images/search.svg";
import magicStarIcon from "assets/images/magic_star.svg";
import aiAssistantIcon from "assets/images/ai-assistant.svg";
import { useLocation, useNavigate } from "react-router-dom";
import rightArrow from "assets/images/right_arrow.svg";
import ToggleNav from "assets/images/toggle_nav.svg";
import useBreakpoint from "utils/useBreakPoint";
import { useTranslation } from "react-i18next";
import { useAiAssistant } from "context/AiAssistantContext";


const Header = (props) => {
  const { onToggleSidebar } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const breakpoint = useBreakpoint();
  const [active, setActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [aiQuery, setAiQuery] = useState("");
  const { toggle: toggleAiPanel, isOpen: aiPanelOpen } = useAiAssistant();

  const handleGoBack = (event) => {
    event.preventDefault();
    navigate(-1);
  };

  const getSearchBase = () => {
    if (location.pathname.startsWith("/news")) return "/news/matching-news";
    if (location.pathname.startsWith("/reports")) return "/reports/search";
    return "/materials/search";
  };

  // Leeres Feld: der Klick auf Lupe/Stern oeffnet das (eingeklappte) Feld und setzt den
  // Cursor hinein, statt still nichts zu tun -- sonst wirkte die Suche "nur manchmal".
  const focusEmptyField = (event) => event.currentTarget.querySelector("input")?.focus();

  const handleSearch = (event) => {
    event.preventDefault();
    if (searchQuery.trim()) {
      const base = getSearchBase();
      navigate(`${base}?q=${encodeURIComponent(searchQuery)}&type=text`);
    } else {
      focusEmptyField(event);
    }
  };

  const handleAISearch = (event) => {
    event.preventDefault();
    if (aiQuery.trim()) {
      const base = getSearchBase();
      navigate(`${base}?q=${encodeURIComponent(aiQuery)}&type=ai`);
    } else {
      focusEmptyField(event);
    }
  };

  return (
    <div className="header-container d-flex justify-content-between align-items-center  py-2">
      {/* Left side */}
      <div className=" header_left_side d-flex gap-2 align-items-center">
        {breakpoint === "mobile" && (
          <div
            className="circle_gridient_btn"
            role="button"
            onClick={onToggleSidebar}
          >
            <img src={ToggleNav} alt={t("header.toggleNav")} className="icon back-icon" />
          </div>
        )}
        {location.pathname === "/" || breakpoint === "mobile" ? null : (
          <div
            className="circle_gridient_btn"
            onClick={handleGoBack}
            role="button"
          >
            <img src={rightArrow} alt={t("header.back")} className="icon back-icon" />
          </div>
        )}

        {(breakpoint === "laptop" || breakpoint === "tablet") && (
          <>
            {/* Search Bar */}
            <form onSubmit={handleSearch} className="search-bar">
              <input
                type="text"
                className="search-txt"
                placeholder={t("header.search.placeholder")}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit" className="search-btn">
                <img src={searchIcon} alt={t("header.search.button")} className="icon" />
              </button>
            </form>

            {/* AI Bar */}
            <form onSubmit={handleAISearch} className="ai_bar">
              <input
                type="text"
                className="search-txt"
                placeholder={t("header.ai.placeholder")}
                value={aiQuery}
                onChange={(e) => setAiQuery(e.target.value)}
              />
              <button type="submit" className="search-btn">
                <img src={magicStarIcon} alt={t("header.ai.button")} className="icon" />
              </button>
            </form>
          </>
        )}
      </div>

      {/* Right side */}

      {(breakpoint === "mobile") && (
        <>
          {/* Search Bar */}
          <form onSubmit={handleSearch} className="search-bar">
              <input
                type="text"
                className="search-txt"
                placeholder={t("header.search.mobilePlaceholder")}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            <button type="submit" className="search-btn">
              <img src={searchIcon} alt={t("header.search.button")} className="icon" />
            </button>
          </form>

          {/* AI Bar */}
          <form onSubmit={handleAISearch} className="ai_bar">
            <input
              type="text"
              className="search-txt"
              placeholder={t("header.ai.askAnything")}
              value={aiQuery}
              onChange={(e) => setAiQuery(e.target.value)}
            />
            <button type="submit" className="search-btn">
              <img src={magicStarIcon} alt={t("header.ai.button")} className="icon" />
            </button>
          </form>
        </>
      )}

      {(breakpoint === "laptop" || breakpoint === "tablet") && (
        <div className="d-flex align-items-center">
          <button
            className={`ai-assistant-btn d-flex align-items-center gap-2${aiPanelOpen ? " ai-assistant-btn--active" : ""}`}
            onClick={toggleAiPanel}
            aria-expanded={aiPanelOpen}
            aria-label={t("header.ai.assistant")}
          >
            <img src={aiAssistantIcon} alt="" />
            <span>{t("header.ai.assistant")}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
